import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import moment from 'moment';
import TableMontlhyRejecteds from './TableMontlhyRejecteds';
import AnimatedBarRejecteds from './AnimatedBarRejecteds';
import CriterialsDescriptions from './CriterialsDescriptions';

let months = [
    { mes: 'Enero', value: '01', number_value: 1 },
    { mes: 'Febrero', value: '02', number_value: 2 },
    { mes: 'Marzo', value: '03', number_value: 3 },
    { mes: 'Abril', value: '04', number_value: 4 },
    { mes: 'Mayo', value: '05', number_value: 5 },
    { mes: 'Junio', value: '06', number_value: 6 },
    { mes: 'Julio', value: '07', number_value: 7 },
    { mes: 'Agosto', value: '08', number_value: 8 },
    { mes: 'Septiembre', value: '09', number_value: 9 },
    { mes: 'Octubre', value: '10', number_value: 10 },
    { mes: 'Noviembre', value: '11', number_value: 11 },
    { mes: 'Diciembre', value: '12', number_value: 12 }
]

const ModalMontlyRejecteds = ({ closeModal, opened }) => {

    const [month1, setMonth1] = useState(null);
    const [month2, setMonth2] = useState(null);
    const [year1, setYear1] = useState(null);
    const [year2, setYear2] = useState(null);
    const [dataIndicatorRejects, setDataIndicatorRejects] = useState([]);

    const getDataCompare = async () => {

        if (
            month1 != null &&
            month1 != undefined &&
            month2 != null &&
            month2 != undefined &&
            year1 != null &&
            year1 != undefined &&
            year2 != null &&
            year2 != undefined
        ) {

            let fecha_inicial1 = moment(`01/${month1}/${year1}`, 'DD/MM/YYYY').toDate();
            let fecha_final1 = moment(fecha_inicial1, 'DD/MM/YYYY').add(1, 'months').subtract(1, 'days').toDate();

            let fecha_inicial2 = moment(`01/${month2}/${year2}`, 'DD/MM/YYYY').toDate();
            let fecha_final2 = moment(fecha_inicial2, 'DD/MM/YYYY').add(1, 'months').subtract(1, 'days').toDate();

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'indicadores/control-registros-comparativa', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    fecha_inicio1: moment(`${moment(fecha_inicial1).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                    fecha_final1: moment(`${moment(fecha_final1).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                    fecha_inicio2: moment(`${moment(fecha_inicial2).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                    fecha_final2: moment(`${moment(fecha_final2).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss')
                })
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error('Data');
                }
            }).then(data => {
                setDataIndicatorRejects(data.indicador.comparacion);
            }).catch(err => {
                setDataIndicatorRejects([]);
                console.log(err);
            });
        }
        else {
            alert("Debe completar todos los Filtros para hacer la Comparativa");
        }
    }

    const prechargeData = () => {
        try {
            let anioActual = new Date().getFullYear();
            let mesActual = new Date().getMonth() + 1;

            setYear1(anioActual);
            setYear2(anioActual);

            let mesActualData = months.find(mon => mon.number_value == mesActual);
            
            setMonth1(mesActualData.value);
            setMonth2(mesActualData.value);
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        prechargeData();
    }, []);

    return (
        <div>
            <Modal
                open={opened}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Comparativa</h5>
                        </div>
                    </div>

                    <Row>
                        <Col md={6} style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }}>
                            <Row>
                                <Col md={6}>
                                    <TextField
                                        id="select-month"
                                        select
                                        label="Seleccione el Año"
                                        value={year1}
                                        className='medical-material-form__field'
                                        onChange={(event) => {
                                            setYear1(event.target.value);
                                        }}
                                        style={{ minWidth: '100%', maxWidth: '100%' }}
                                    >
                                        <MenuItem key={0} value={2020}>2020</MenuItem>
                                        <MenuItem key={1} value={2021}>2021</MenuItem>
                                        <MenuItem key={2} value={2022}>2022</MenuItem>
                                    </TextField>
                                    <br /><br />
                                </Col>
                                <Col md={6}>
                                    <TextField
                                        id="select-month"
                                        select
                                        label="Seleccione el Mes"
                                        value={month1}
                                        className='medical-material-form__field'
                                        onChange={(event) => {
                                            setMonth1(event.target.value);
                                        }}
                                        style={{ minWidth: '100%', maxWidth: '100%' }}
                                    >
                                        {
                                            months.map((month, index) => {
                                                return <MenuItem key={month.value} value={month.value}>{month.mes}</MenuItem>
                                            })
                                        }
                                    </TextField>
                                    <br /><br />
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6} style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }}>
                            <Row>
                                <Col md={6}>
                                    <TextField
                                        id="select-month"
                                        select
                                        label="Seleccione el Año"
                                        value={year2}
                                        className='medical-material-form__field'
                                        onChange={(event) => {
                                            setYear2(event.target.value);
                                        }}
                                        style={{ minWidth: '100%', maxWidth: '100%' }}
                                    >
                                        <MenuItem key={0} value={2020}>2020</MenuItem>
                                        <MenuItem key={1} value={2021}>2021</MenuItem>
                                        <MenuItem key={2} value={2022}>2022</MenuItem>
                                    </TextField>
                                    <br /><br />
                                </Col>
                                <Col md={6}>
                                    <TextField
                                        id="select-month"
                                        select
                                        label="Seleccione el Mes"
                                        value={month2}
                                        className='medical-material-form__field'
                                        onChange={(event) => {
                                            setMonth2(event.target.value);
                                        }}
                                        style={{ minWidth: '100%', maxWidth: '100%' }}
                                    >
                                        {
                                            months.map((month, index) => {
                                                return <MenuItem key={month.value} value={month.value}>{month.mes}</MenuItem>
                                            })
                                        }
                                    </TextField>
                                    <br /><br />
                                </Col>
                            </Row>
                        </Col>

                        {
                            dataIndicatorRejects.length > 0 ? <Col md={12} style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }}>
                                <Row>
                                    <Col md={7}>
                                        <div style={{ maxHeight: '550px', overflowY: 'scroll' }}>
                                            <TableMontlhyRejecteds reactTableData={dataIndicatorRejects} yearVisible={true} />
                                        </div>
                                    </Col>
                                    <Col md={5}>
                                        <AnimatedBarRejecteds dataIndicator={dataIndicatorRejects} />
                                        <br />
                                        <CriterialsDescriptions />
                                    </Col>
                                </Row>
                            </Col> : null
                        }

                    </Row>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                getDataCompare();
                            }}
                        >
                            Comparar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default ModalMontlyRejecteds;
